export enum ArticleType {
  Default = 0,
  Article = 1,
  Video = 2,
}

export enum ArticleSearchType {
  TagAndTitle = 1,
  Tag = 2,
}
